import * as React from 'react';

function SvgOpenBase(props) {
  return (
    <svg data-name="Open v02" viewBox="0 0 420 337.4" {...props}>
      <path
        fill="none"
        stroke="#32cb87"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M210.12 336.08L210.12 336.07M210.12 336.08L210.12 336.07"
      />
      <path
        fill="#b0f2dc"
        d="M211.28 216.24L211.28 334.07 313.32 275.16 313.32 157.32 211.28 216.24zM165.82 121.96L108.08 155.31 208.96 213.56 208.96 97.08 208.96 97.08 205.66 98.99 165.82 121.96z"
      />
      <path
        fill="#32cb87"
        d="M419.42,94.05,315.06,33.79a1.18,1.18,0,0,0-1.15,0L210.1,93.73,106.28,33.79a1.17,1.17,0,0,0-1.17,0L.77,94.05a1.16,1.16,0,0,0,0,2l.07,0s0,0,0,0L104.6,156V275.82a1.15,1.15,0,0,0,.58,1l104.36,60.26.08,0,.12.05a1.55,1.55,0,0,0,.31.06l.08,0a1.1,1.1,0,0,0,.58-.16l104.35-60.25a1.16,1.16,0,0,0,.58-1V156l103.78-59.9a1.16,1.16,0,0,0,0-2ZM105.7,154l-8-4.61L3.78,95.12l-.11-.06,102-58.92L207.76,95.06l0,0h0l-3.17,1.83L166.84,118.7l-3.42,2L105.71,154ZM209,334.06l-102-58.91V157.34l76.53,44.17L209,216.24Zm0-237V213.56L108.08,155.31,165.82,122l39.84-23,3.3-1.91ZM314.49,36.14l102,58.92-102,58.9-45-26L212.43,95.06ZM211.28,213.56V97.11h0l44.23,25.51,4.58,2.64,52.09,30h0l-100.9,58.26Zm102,61.6-102,58.91V216.24l102-58.92Z"
      />
    </svg>
  );
}

export default SvgOpenBase;
